import { Box, Button, Container, Grid, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"

import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Moment from "react-moment"
import { NavLink } from "react-router-dom"
import { StyledTableContainer } from "shared/styled/Global"

const ListFuelData = () => {
  const { t } = useTranslation()
  const loadingContext = useContext(GlobalLoaderContext)

  const [vehiclesResult, vehiclesFuncs] = useApi()
  const [page, setPage] = useState(1)
  const [pageCount, setPageCount] = useState(0)
  const [pageSize, setPageSizeManual] = useState(25)
  const [sortState, setSortState] = useState({
    sortby: "regNumber",
    direction: "asc"
  })
  useEffect(() => {
    vehiclesFuncs.get(
      apiEndpoints.vehicleregistryadmin.getimporttedrows
        .replace("{page}", page)
        .replace("{pagesize}", pageSize)
        .replace("{sortby}", sortState.sortby + " " + sortState.direction)
    )
  }, [vehiclesFuncs, page, pageSize, sortState.direction, sortState.sortby])

  useEffect(() => {
    if (vehiclesResult.status === 2) {
      setPageCount(vehiclesResult.data.pageCount)
    }
  }, [vehiclesResult])

  useEffect(() => {
    loadingContext.setLoading(() => vehiclesResult.status === 1)
  })

  const columns = [
    {
      accessorKey: "regNumber",
      header: t("global.table.regnr", "Reg No")
    },
    {
      accessorKey: "internnumber",
      header: t("global.table.internal_number", "Internal No")
    },
    {
      accessorKey: "propellant",
      header: t("global.fuel", "Fuel")
    },
    {
      accessorKey: "odometer",
      header: t("global.meter_setting", "Meter setting")
    },
    {
      accessorKey: "propellantVolume",
      header: t("reports.volume", "Volume")
    },
    {
      accessorKey: "transactionTime",
      header: t("reports.transaction_date", "Transaction Date"),
      cell: ({ cell }) => {
        return (
          <Moment format="YYYY-MM-DD HH:mm" globallocale="sv">
            {cell.row.original.transactionTime}
          </Moment>
        )
      }
    }
  ]
  return (
    <div>
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            {" "}
            <Typography variant="h1">{t("global.tank_files", "Tank files")}</Typography>
            <Button
              component={NavLink}
              to={allRoutes.ReportsVehiclereportsFueldataImport()}
              color="primary"
              variant="contained">
              {t("global.import_tank_files", "Import tank files")}
            </Button>
          </Grid>
        </Box>{" "}
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          pageCount={pageCount}
          pageSize={pageSize}
          currentpage={page}
          totalPage={pageCount}
          manualPagination={true}
          manualSortBy={true}
          setPage={setPage}
          setPageSizeManual={setPageSizeManual}
          manualPageSize={pageSize}
          hideSearch={true}
          hideFilter={true}
          manualSetSortState={setSortState}
          manualSortState={sortState}
          rows={vehiclesResult.status === 2 && vehiclesResult.data}
          loadingState={vehiclesResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}
export default ListFuelData
